// IMPORTANT: Sentry instrument must be imported FIRST before any other imports
import "./instrument";

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";

// Google sign-in no longer runs in the page (see lib/googleSignIn), so there
// is no Google provider and no client id in the browser bundle.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
